import http from '@/services/http.js';

export const createOrder = async (payload) => {
  try {
    const response = await http.post(`/videoapi/infoUpload/create`, payload);
    return response;
  } catch (error) {
    console.error('创建订单失败', error);
    throw error;
  }
};

export const deleteOrder = async (client_id, isDelete) => {
  try {
    const response = await http.put(`/videoapi/infoUpload/delete/${client_id}`, {
      isDelete,
    });
    return response;
  } catch (error) {
    console.error('删除订单失败', error);
    throw error;
  }
};

export const autoSaveValue = async (client_id, fieldName, fieldValue) => {
  try {
    const response = await http.post(`/videoapi/infoUpload/autoSave`, {
      client_id,
      fieldName,
      fieldValue,
    });
    return response;
  } catch (error) {
    console.error('自动保存失败', error);
    throw error;
  }
};

export const updateVideoTypeAction = async (client_id, videoTypeId, custom_price) => {
  try {
    const response = await http.post(`/videoapi/infoUpload/updateVideoType`, {
      client_id,
      videoTypeId,
      custom_price,
    });
    return response;
  } catch (error) {
    console.error('更新视频套餐失败', error);
    throw error;
  }
};

export const genClientId = async () => {
  const response = await http.get(`/videoapi/infoUpload/generateId`);
  return response;
};
